import { Controller } from 'stimulus';
import { formatCurrency } from '@/js/shared/billables/currency';
import { decimal } from '@/js/shared/billables/decimal';

const HIGH_PERCENTAGE = '50';

export default class extends Controller {
  static targets = [
    'calculatedAmount',
    'methodSelect',
    'amountField',
    'amountInput',
    'percentageField',
    'percentageInput',
    'perItemToggle',
    'warning',
    'warningPercentage',
  ];

  #warningDismissed = false;

  get calculationInput() {
    if (!this.hasMethodSelectTarget) {
      return { method: 'per_line' };
    }

    return {
      method: this.methodSelectTarget.value,
      amount: this.amountInputTarget.value || '0',
      percentage: this.percentageInputTarget.value || '0',
    };
  }

  connect() {
    this.#syncInputState();
  }

  changeMethod() {
    this.#syncInputState();
    this.#hideWarning();
    this.dispatch('method-changed', { detail: { method: this.methodSelectTarget.value } });
    this.dispatch('changed');
  }

  update() {
    this.#syncWarning();
    this.dispatch('changed');
  }

  dismissWarning() {
    this.#warningDismissed = true;
    this.#hideWarning();
  }

  renderCalculatedAmount({ shipping, currency }) {
    this.calculatedAmountTarget.textContent = formatCurrency(shipping, currency, {
      useGrouping: false,
    });
  }

  #syncWarning() {
    if (!this.hasWarningTarget || this.#warningDismissed) {
      return;
    }

    const { method, percentage } = this.calculationInput;
    const value = decimal(percentage);

    if (method !== 'percentage' || !value.gt(HIGH_PERCENTAGE)) {
      this.#hideWarning();
      return;
    }

    this.warningPercentageTarget.textContent = value.toString();
    this.warningTarget.classList.remove('hide');
  }

  #hideWarning() {
    if (this.hasWarningTarget) {
      this.warningTarget.classList.add('hide');
    }
  }

  #syncInputState() {
    if (!this.hasMethodSelectTarget) {
      return;
    }

    const method = this.methodSelectTarget.value;
    this.amountFieldTarget.classList.toggle('hide', method !== 'flat');
    this.percentageFieldTarget.classList.toggle('hide', method !== 'percentage');
    this.perItemToggleTarget.classList.toggle('hide', method !== 'per_line');
  }
}
